import { createSlice } from "@reduxjs/toolkit";
import {
  getPulseOverview,
  getPulseProjects,
  getPulsePortals,
  getPulsePortal,
  getPulseReliability,
  getPulseCheckHistory,
  getPulseSamples,
  getPulseIncidents,
  getPulseHourly,
  getPulseDaily,
  getPulseReports,
  getPulseReport,
  triggerPulsePoll,
} from "./pulseThunk";

const initialState = {
  overview: null,
  projects: [],
  portals: [],
  portal: null,
  reliability: null,
  checkHistory: null,
  samples: [],
  incidents: [],
  hourly: [],
  daily: [],
  reports: [],
  report: null,
  loading: false,
  polling: false,
};

const pulseSlice = createSlice({
  name: "pulse",
  initialState,
  reducers: {
    clearPulseReport: (state) => {
      state.report = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPulseOverview.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPulseOverview.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.overview = payload?.result || null;
      })
      .addCase(getPulseOverview.rejected, (state) => {
        state.loading = false;
      })
      .addCase(getPulseProjects.fulfilled, (state, { payload }) => {
        state.projects = payload?.result || [];
      })
      .addCase(getPulsePortals.fulfilled, (state, { payload }) => {
        state.portals = payload?.result || [];
      })
      .addCase(getPulsePortal.fulfilled, (state, { payload }) => {
        state.portal = payload?.result || null;
      })
      .addCase(getPulseReliability.fulfilled, (state, { payload }) => {
        state.reliability = payload?.result || null;
      })
      .addCase(getPulseCheckHistory.fulfilled, (state, { payload }) => {
        state.checkHistory = payload?.result || null;
      })
      .addCase(getPulseSamples.fulfilled, (state, { payload }) => {
        state.samples = payload?.result || [];
      })
      .addCase(getPulseIncidents.fulfilled, (state, { payload }) => {
        state.incidents = payload?.result || [];
      })
      .addCase(getPulseHourly.fulfilled, (state, { payload }) => {
        state.hourly = payload?.result || [];
      })
      .addCase(getPulseDaily.fulfilled, (state, { payload }) => {
        state.daily = payload?.result || [];
      })
      .addCase(getPulseReports.fulfilled, (state, { payload }) => {
        state.reports = payload?.result || [];
      })
      .addCase(getPulseReport.fulfilled, (state, { payload }) => {
        state.report = payload?.result || null;
      })
      .addCase(triggerPulsePoll.pending, (state) => {
        state.polling = true;
      })
      .addCase(triggerPulsePoll.fulfilled, (state) => {
        state.polling = false;
      })
      .addCase(triggerPulsePoll.rejected, (state) => {
        state.polling = false;
      });
  },
});

export const { clearPulseReport } = pulseSlice.actions;
export default pulseSlice.reducer;
